<div class="agreement-settings">
  <div class="page-header">
    <h3 class="page-title">Agreement Settings</h3>
    <div class="page-subtitle">Settings used when sending and validating agreements.</div>
  </div>

  <div class="settings-grid">
    <!-- Validation manager: single user who validates agreements -->
    <mat-card class="content-card setting-card">
      <div class="setting-header">
        <div class="setting-icon"><mat-icon>verified_user</mat-icon></div>
        <div class="setting-heading">
          <div class="setting-title">
            Validation Manager
          </div>
          <div class="setting-hint">The LM Credit Manager who validates agreements.</div>
        </div>
      </div>

      <div class="setting-body">
        <form [formGroup]="managerForm">
          <mat-form-field appearance="outline" class="manager-field">
            <mat-label>Select Manager</mat-label>
            <mat-select formControlName="manager" panelClass="custom-select-panel">
              <mat-option>
                <ngx-mat-select-search
                  formControlName="managerSearch"
                  placeholderLabel="Search manager..."
                  noEntriesFoundLabel="No matching results">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let user of filteredUsers | async" [value]="user.full_name">
                {{ user.full_name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="managerForm.controls['manager'].hasError('required') && managerForm.controls['manager'].touched">
              Manager is required
            </mat-error>
          </mat-form-field>
        </form>

        <div class="setting-actions">
          <button
            mat-raised-button
            color="primary"
            (click)="updateValidationManager()"
            [disabled]="managerForm.invalid || isSavingManager">
            <mat-spinner *ngIf="isSavingManager" diameter="16" class="btn-spinner"></mat-spinner>
            <span *ngIf="!isSavingManager">Save</span>
          </button>
        </div>
      </div>
    </mat-card>

    <div *ngIf="isLoadingPermissions" class="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Agreement permissions: on/off switch plus who is granted -->
    <ng-container *ngIf="!isLoadingPermissions">
      <mat-card
        *ngFor="let permission of permissions"
        class="content-card setting-card"
        [class.is-off]="!enabled[permission.key]">
        <div class="setting-header">
          <div class="setting-icon"><mat-icon>{{ permission.icon }}</mat-icon></div>
          <div class="setting-heading">
            <div class="setting-title">
              {{ permission.label }}
              <mat-spinner *ngIf="isSaving(permission.key)" diameter="14"></mat-spinner>
            </div>
            <div class="setting-hint">{{ permission.hint }}</div>
          </div>
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="enabled[permission.key]"
            (change)="savePermission(permission.key)"
            [attr.aria-label]="'Enable ' + permission.label">
          </mat-slide-toggle>
        </div>

        <div class="setting-body">
          <div class="granted-label">
            <ng-container *ngIf="enabled[permission.key]; else offLabel">
              Granted to {{ selected[permission.key].length }}
              {{ selected[permission.key].length === 1 ? 'user' : 'users' }}
            </ng-container>
            <ng-template #offLabel>
              <mat-icon class="off-icon">block</mat-icon>{{ permission.disabledHint }}
            </ng-template>
          </div>

          <app-user-picker
            [users]="permissionUsers"
            [ngModel]="selected[permission.key]"
            (ngModelChange)="onUsersChange(permission.key, $event)"
            [disabled]="!enabled[permission.key]"
            disabledPlaceholder="Enable to add or remove users"
            [ariaLabel]="permission.label + ' users'">
          </app-user-picker>
        </div>
      </mat-card>
    </ng-container>
  </div>
</div>
